import {
  FETCH_VIDEOS_LIST_FAILURE,
  FETCH_VIDEOS_LIST_SUCCESS,
  FETCH_COUNSELING_TIMELINE_SUCCESS,
  FETCH_COUNSELING_TIMELINE_FAILURE,
  FETCH_COUNSELLINGS_SUCCESS,
  FETCH_COUNSELLINGS_FAILURE,
  FETCH_DASHBOARD_INFO_SUCCESS,
  FETCH_DASHBOARD_INFO_FAILURE,
  FETCH_SOCIAL_MEDIA_UPDATES_SUCCESS,
  FETCH_SOCIAL_MEDIA_UPDATES_FAILURE,
  FETCH_BULLETINS_SUCCESS,
  FETCH_BULLETINS_FAILURE,
  FETCH_ANNOUNCEMENT_FILTERS_SUCCESS,
  FETCH_ANNOUNCEMENT_FILTERS_FAILURE,
  FETCH_EVENT_FILTERS_SUCCESS,
  FETCH_EVENT_FILTERS_FAILURE,
} from "redux/constant";

const initialState = {
  videosList: [],
  counsellingTimeline: [],
  counsellings: [],
  selectedCounseling: null,
  info: null,
  socialMediaUpdates: [],
  bulletins: [],
  annFilterData: [],
  eventFilterData: [],
  error: null,
};

const postsubscription = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VIDEOS_LIST_SUCCESS:
      return {
        ...state,
        videosList: action.payload,
        error: null,
      };
    case FETCH_VIDEOS_LIST_FAILURE:
      return {
        ...state,
        videosList: [],
        error: action.payload,
      };
    case FETCH_COUNSELING_TIMELINE_SUCCESS:
      return {
        ...state,
        counsellingTimeline: action.payload,
        error: null,
      };
    case FETCH_COUNSELING_TIMELINE_FAILURE:
      return {
        ...state,
        counsellingTimeline: [],
        error: action.payload,
      };
    case FETCH_COUNSELLINGS_SUCCESS:
      const data = action.payload.counsellings || [];
      const setCounsellings = ({ id, name }) => ({ value: id, label: name });
      const counsellings = data.map(setCounsellings);
      return {
        ...state,
        counsellings: counsellings,
        selectedCounseling: counsellings[0],
        error: null,
      };
    case FETCH_COUNSELLINGS_FAILURE:
      return {
        ...state,
        counsellings: [],
        error: action.payload,
      };
    case FETCH_DASHBOARD_INFO_SUCCESS:
      return {
        ...state,
        info: action.payload,
        error: null,
      };
    case FETCH_DASHBOARD_INFO_FAILURE:
      return {
        ...state,
        info: null,
        error: action.payload,
      };
    case FETCH_SOCIAL_MEDIA_UPDATES_SUCCESS:
      return {
        ...state,
        socialMediaUpdates: action.payload,
        error: null,
      };
    case FETCH_SOCIAL_MEDIA_UPDATES_FAILURE:
      return {
        ...state,
        socialMediaUpdates: [],
        error: action.payload,
      };
    case FETCH_BULLETINS_SUCCESS:
      return {
        ...state,
        bulletins: action.payload,
        error: null,
      };
    case FETCH_BULLETINS_FAILURE:
      return {
        ...state,
        bulletins: [],
        error: action.payload,
      };
    case FETCH_ANNOUNCEMENT_FILTERS_SUCCESS:
      const announcements = action.payload?.counsellings || [];
      const setannouncement = (ann) => ({ value: ann, label: ann });
      const annFilterData = announcements.map(setannouncement);
      return {
        ...state,
        annFilterData,
        error: null,
      };
    case FETCH_ANNOUNCEMENT_FILTERS_FAILURE:
      return {
        ...state,
        annFilterData: [],
        error: action.payload,
      };
    case FETCH_EVENT_FILTERS_SUCCESS:
      const events = action.payload?.counsellings || [];
      const setevents = (ann) => ({ value: ann, label: ann });
      const eventFilterData = events.map(setevents);
      return {
        ...state,
        eventFilterData,
        error: null,
      };
    case FETCH_EVENT_FILTERS_FAILURE:
      return {
        ...state,
        eventFilterData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default postsubscription;
